import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { UserManagementList } from '@/components/pages/Admin/UserManagement/List'
import { useTranslations } from '@/hooks/useTranslations'
import { LinkButton } from '@/components/ui'

export const Route = createFileRoute('/(dashboard)/admin/user/')({
  component: UserPage,
})

function UserPage() {
  const t = useTranslations('admin.user_management')

  return (
    <HomeContentContainer title={t('title')} rightContent={<LinkButton to="/admin/user/create">สร้างผู้ใช้งาน</LinkButton>}>
      <UserManagementList />
    </HomeContentContainer>
  )
}

